import { m } from "framer-motion";

import { Divider, NavMobileBottom, NavMobileTop } from "@theme/components";

import type { ThemeUIStyleObject } from "@theme/components";
import type { NavigationDataProps } from "@theme/types";
import type { DrawerActions, DrawerState } from "@theme/utils/hooks/useDrawer";
import type { RefObject } from "react";

interface NavMobileMainScreenProps {
  navData: NavigationDataProps;
  categoryRefs: { current: RefObject<HTMLElement>[] };
  NavLinkTextStyles: ThemeUIStyleObject;
  showAccordion: (index: number) => void;
  drawerState: DrawerState & DrawerActions;
}

export const NavMobileMainScreen = ({
  navData,
  categoryRefs,
  NavLinkTextStyles,
  showAccordion,
  drawerState,
}: NavMobileMainScreenProps) => {
  const { currentView, closeDrawer } = drawerState;

  return (
    <m.div
      variants={{
        hide: { x: "-100%" },
        show: { x: 0 },
      }}
      initial="show"
      animate={currentView.type === "main" ? "show" : "hide"}
      transition={{ ease: [1, 0, 0, 1], duration: 0.3 }}
      sx={{
        position: "absolute",
        display: "flex",
        inset: 0,
        flexDirection: "column",
        alignSelf: "stretch",
        gap: "s600",
        px: ["s600", "s700"],
        py: ["s400", "s700"],
      }}
    >
      <NavMobileTop
        navCategories={navData.siteNavData?.mobileCategories ?? []}
        categoryRefs={categoryRefs}
        setIsDrawerOpen={closeDrawer}
        NavLinkTextStyles={NavLinkTextStyles}
        showAccordion={showAccordion}
      />
      <Divider aria-hidden={true} sx={{ my: "s400", color: "grey100" }} />
      <NavMobileBottom
        navData={navData}
        onClose={closeDrawer}
        NavLinkTextStyles={NavLinkTextStyles}
        drawerState={drawerState}
      />
    </m.div>
  );
};
